<div
  class="sm-dialog-title dialog-box"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  [ngClass]="data.styleClass || ''"
>
  <div class="header-highlight bg-green-300"></div>
  <div
    cdkDragHandle
    mat-dialog-title
    class="cursor-move sm-dialog-title dialog-header !text-[1.2rem]"
  >
    {{ data.title }}
  </div>

  @if (data.isInnerHtml) {
    <div mat-dialog-content class="sm-dialog-content">
      <div class="text-lg" [innerHtml]="data.innerHtmlContent"></div>
      @if (data.subDescription) {
        <div class="mt-2">
          <span class="text-base">{{ data.subDescription }}</span>
        </div>
      }
    </div>
  } @else {
    <div mat-dialog-content class="sm-dialog-content">
      <div>
        <span class="text-lg">{{ data.description }}</span>
      </div>
      @if (data.subDescription) {
        <div class="mt-2">
          <span class="text-base">{{ data.subDescription }}</span>
        </div>
      }
    </div>
  }

  <mat-divider class="divider-margin"></mat-divider>

  <div mat-dialog-actions class="sm-mat-dialog-actions">
    <!-- primary buttons should go first -->
    <button
      mat-flat-button
      *ngIf="showButton('ok')"
      class="primary-button"
      cdkFocusInitial
      (click)="onClick('ok')"
    >
      Ok
    </button>
    <button
      mat-flat-button
      *ngIf="showButton('confirm')"
      class="primary-button"
      cdkFocusInitial
      (click)="onClick('confirm')"
    >
      Confirm
    </button>
    <button
      mat-flat-button
      *ngIf="showButton('delete')"
      class="primary-button"
      cdkFocusInitial
      (click)="onClick('delete')"
    >
      Delete
    </button>
    <button
      mat-flat-button
      *ngIf="showButton('stay')"
      class="primary-button"
      cdkFocusInitial
      (click)="onClick('stay')"
    >
      Stay
    </button>
    <!-- secondary buttons should go next -->
    <button
      mat-flat-button
      *ngIf="showButton('cancel')"
      class="secondary-button"
      (click)="onClick('cancel')"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      *ngIf="showButton('logout')"
      class="secondary-button"
      (click)="onClick('logout')"
    >
      Logout
    </button>
  </div>
</div>
